import { Component, forwardRef } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../../utils/Loader";

import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { downloadReport, toastError, toastSuccess, applicationHistoryExhibitorId, exhibitionId } from "../../../../utils/constants";
import { getApplicationHistoryList_action } from '../../../../actions/admin_module_action/manage_area/application_history_action/application_history_action'
import Pagination from "../../../../utils/pagination";
import { fill_action } from '../../../../actions/fillCombo_action';
import moment from "moment";
import Workbook from 'react-excel-workbook'
import * as XLSX from 'xlsx';
class ApplicationHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            ApplicationHistoryList: [],
            exhibitorId: '',
            exhibitorList: [],
            BookingDate: '',
            ApplicationRefno: '',
            exhibitionId: '',
            exhibitionList: []
        }

        this.updateItem = this.updateItem.bind(this)
    }

    // On Component Load
    componentDidMount() {
        this.getFillList(applicationHistoryExhibitorId, null, '', '', '', '');
        this.getFillList(exhibitionId, null, '', '', '', '');
        this.getApplicationHistoryList()

    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
            .then((data) => {
                if (data.error != 1) {
                    // voucher list
                    if (actionID === applicationHistoryExhibitorId) {
                        // console.log("exhibitorList", data.data)
                        this.setState({
                            exhibitorList: data.data, isLoading: false,
                        })
                    }
                    if (actionID === exhibitionId) {
                        // console.log("voucher type data", data.data)
                        this.setState({
                            exhibitionList: data.data, isLoading: false,
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getApplicationHistoryList() {
        const { exhibitorId } = this.state
        this.setState({ isLoading: true })
        this.props.getApplicationHistoryList_action(exhibitorId)
            .then((data) => {
                if (data.error != 1) {

                    if (data.data != '') {
                        if (data.data[0]['emptyData'] != 'empty') {
                            this.setState({
                                isLoading: false,
                                ApplicationHistoryList: data.data
                            })
                        } else {
                            this.setState({
                                isLoading: false,
                                ApplicationHistoryList: []
                            })
                        }
                    } else {
                        this.setState({
                            isLoading: false,
                            ApplicationHistoryList: data.data
                        })
                    }

                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    // to create excel file
    exportToExcel() {
        const { ApplicationHistoryList } = this.state

        ApplicationHistoryList.map((data) => {
            delete data.AccountID
            delete data.CountryID
            delete data.CreatedBy
            delete data.ExhRegistrationID
            delete data.ExhRegistrationLogID
            delete data.ExhibitionID
            delete data.ExhibitionStallSizeID
            delete data.InvCountryID
            delete data.Modifiedy
            delete data.PrimaryChapter
            delete data.StallTypeID
            delete data.StatusID
        })

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Convert the data to a worksheet
        const ws = XLSX.utils.json_to_sheet(ApplicationHistoryList);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // Save the workbook to an Excel file
        XLSX.writeFile(wb, 'Application_History.xlsx');
    };

    handleClear() {
        const { ApplicationHistoryList } = this.state

        this.setState({
            exhibitorId: '',
            BookingDate: '',
            ApplicationRefno: '',
            exhibitionId: '',
        })
        setTimeout(() => {
            this.getApplicationHistoryList()
        }, 100);
    }


    updateItem(item) {
        const { ApplicationHistoryList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = ApplicationHistoryList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(ApplicationHistoryList.length / recordsPerPage)
    }

    onExhibitor(e) {
        const { exhibitorList } = this.state

        this.setState({ exhibitorId: e.target.value })

        if (e.target.value != '' && e.target.value != 'Select') {
            exhibitorList.map((data) => {
                if (data.ExhRegistrationID == e.target.value) {
                    this.setState({
                        BookingDate: data.BookingDate,
                        ApplicationRefno: data.ApplicationRefno,
                    })
                }
            })
            setTimeout(() => {
                this.getApplicationHistoryList()
            }, 100);
        } else {
            this.setState({
                BookingDate: '',
                ApplicationRefno: '',
            })
            this.setState({ exhibitorId: '' })
        }
    }

    onExhibitionSelect(e) {
        const { exhibitorList } = this.state
        const value = e.target.value

        if (value != '' && value != 'Select') {
            this.setState({ exhibitionId: value })
            this.getFillList(applicationHistoryExhibitorId, value, '', '', '', '');
            this.getFillList(exhibitionId, value, '', '', '', '');
        } else {
            this.setState({ exhibitionId: '', exhibitorId: '', BookingDate: '', ApplicationRefno: '' })
            this.getFillList(applicationHistoryExhibitorId, null, '', '', '', '');
            this.getFillList(exhibitionId, null, '', '', '', '');
        }
    }

    render() {
        const { isLoading, ApplicationHistoryList, exhibitorId, exhibitorList, currentPage, BookingDate, ApplicationRefno, exhibitionId, exhibitionList } = this.state

        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = ApplicationHistoryList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(ApplicationHistoryList.length / recordsPerPage)

        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />

                  <div className="main-content">

  {/* ===== FILTER / INFO SECTION ===== */}
  <div className="card mb-0">
    <div className="card-body">

      <div className="row align-items-end g-3">

        {/* Exhibition */}
        <div className="col-12 col-md-3">
          <label className="">Exhibition</label>
          <select
            className="form-control"
            value={exhibitionId}
            onChange={(e) => this.onExhibitionSelect(e)}
          >
            <option value="">Select</option>
            {exhibitionList.map((data) => (
              <option key={data.ExhibitionID} value={data.ExhibitionID}>
                {data.ExhibitionName}
              </option>
            ))}
          </select>
        </div>

        {/* Exhibitor */}
        <div className="col-12 col-md-3">
          <label className="">Exhibitor</label>
          <select
            className="form-control"
            value={exhibitorId}
            onChange={(e) => this.onExhibitor(e)}
          >
            <option value="">Select</option>
            {exhibitorList.map((data) => (
              <option key={data.ExhRegistrationID} value={data.ExhRegistrationID}>
                {data.ExhibitorName}
              </option>
            ))}
          </select>
        </div>

        {/* Booking Date */}
        <div className="col-12 col-md-3">
          <label className="">Booking Date</label>
          <div className="form-control bg-light">
            {BookingDate ? moment(BookingDate).format('DD-MM-YYYY') : '-'}
          </div>
        </div>

        {/* Application Ref */}
        <div className="col-12 col-md-3">
          <label className="">Application Ref No</label>
          <div className="form-control bg-light">
            {ApplicationRefno || '-'}
          </div>
        </div>

      </div>

      {/* ACTION BUTTONS */}
      <div className="d-flex justify-content-end gap-2 mt-3">

        <button
          className="btn btn-aqua"
          onClick={() => this.handleClear()}
        >
          Clear
        </button>

        {/* {ApplicationHistoryList !== '' && (
          <button
            className="btn btn-aqua"
            onClick={() => this.exportToExcel()}
          >
            Download Excel
          </button>
        )} */}

      </div>

    </div>
  </div>

  {/* ===== TABLE SECTION ===== */}
  <div className="card">
    <div className="card-body table-responsive">

      <table className="table table-bordered text-nowrap mb-0">
        <thead className="table-light">
          <tr>
            <th>Exhibitor Name</th>
            <th>Modified Date</th>
            <th>Stall Type</th>
            <th>Area</th>
            <th>Open Side</th>
            <th>Booking Status</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords && currentRecords.length > 0 ? (
            currentRecords.map((data, i) => (
              <tr key={i}>
                <td>{data.CompanyName}</td>
                <td>{data.ModifiedDate ? moment(data.ModifiedDate).format('DD-MM-YYYY') : '-'}</td>
                <td>{data.StallTypeName}</td>
                <td>{data.StallArea}</td>
                <td>{data.OpenSides}</td>
                <td>{data.BookingStatus}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center text-muted">
                Record not found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* PAGINATION */}
      <div className="d-flex justify-content-between align-items-center mt-2">
        {ApplicationHistoryList.length > 0 && (
          <Pagination
            nPages={nPages}
            currentPage={currentPage}
            setCurrentPage={this.updateItem}
          />
        )}
        <span className="text-muted">
          {`${currentPage} of ${nPages} pages`}
        </span>
      </div>

    </div>
  </div>

</div>


                </>

                {/* <Footerwithdr /> */}

            </>
        );
    }


}

export default withRouter(connect(null, { fill_action, getApplicationHistoryList_action })(ApplicationHistory));